import { Form, Input } from "decorator-form";

import { ILayout, LayoutType } from "common/form/fields/layoutField/LayoutField";
import InputType from "common/form/InputType";

@Form({title: "Layout"})
export default class LayoutConfig {

	@Input({type: InputType.LAYOUT, title: "Layout Type"})
	public layout: ILayout = { type: LayoutType.COLUMN, columns: []};

	@Input({type: InputType.CHECKBOX, title: "Full height"})
	public fullHeight: boolean = false;

	@Input({type: InputType.UNIT, title: "Responsive Breakpoint"})
	public breakPoint: string;
}



// WEBPACK FOOTER //
// ./src/panels/layout/LayoutConfig.ts